/* Lumiere: urun gorseline basinca tam ekran goruntuleyici (kaydir, iki parmakla / cift dokunusla buyut, X ile kapat; videolar sessiz kendiliginden oynar) */
(function () {
  var list = document.querySelector('.product__media-list');
  if (!list) return;
  var box, track, count, slides = [], cur = 0;
  var VID = 'deferred-media, video';

  function big(img) {
    var s = img.currentSrc || img.src || '';
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return /[?&]width=\d+/.test(s) ? s.replace(/([?&])width=\d+/, '$1width=1800') : s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=1800';
  }
  // Goruntuleyiciye girecek kareler: fotograflar ve videolar (3D/iframe haric)
  function items() {
    return [].slice.call(list.querySelectorAll('.product__media-item')).filter(function (x) {
      return !x.querySelector('iframe, model-viewer') && (x.querySelector(VID) || x.querySelector('img'));
    });
  }
  function videoOf(li) {
    var tpl = li.querySelector('deferred-media template');
    var v = (tpl && tpl.content.querySelector('video')) || li.querySelector('video');
    if (!v) return null;
    var c = v.cloneNode(true);
    c.removeAttribute('autoplay'); c.removeAttribute('controls');
    c.muted = true; c.loop = true; c.playsInline = true; c.preload = 'metadata';
    c.setAttribute('muted', ''); c.setAttribute('loop', ''); c.setAttribute('playsinline', '');
    return c;
  }

  function build() {
    box = document.createElement('div');
    box.className = 'nk-zm';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', 'Ürün görselleri');
    box.innerHTML = '<button type="button" class="nk-zm__x" aria-label="Kapat">✕</button><div class="nk-zm__track"></div><div class="nk-zm__n"></div>';
    track = box.querySelector('.nk-zm__track');
    count = box.querySelector('.nk-zm__n');
    items().forEach(function (li) {
      var s = document.createElement('div');
      s.className = 'nk-zm__slide';
      var el;
      if (li.querySelector(VID)) {
        el = videoOf(li);
        if (!el) return;
        s.appendChild(el);
        // Tema baska yerden tum videolari durdurabilir; pencere acikken ekrandaki videoyu tekrar baslat
        (function (v) { v.addEventListener('pause', function () { setTimeout(function () { if (box && !box.hidden && slides[cur] === v && v.paused) playV(v); }, 150); }); })(el);
      } else {
        var img = li.querySelector('img');
        el = document.createElement('img');
        el.alt = img.alt || '';
        el.draggable = false;
        el.setAttribute('data-src', big(img));
        s.appendChild(el);
        pinch(s, el);
      }
      track.appendChild(s);
      slides.push(el);
    });
    box.querySelector('.nk-zm__x').addEventListener('click', close);
    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (n !== cur) { reset(slides[cur]); cur = n; load(n); label(); media(); }
    }, { passive: true });
    document.addEventListener('keydown', function (e) { if (!box.hidden && e.key === 'Escape') close(); });
    document.body.appendChild(box);
  }

  function isVid(el) { return el && el.tagName === 'VIDEO'; }
  function playV(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function load(n) {
    [n, n + 1, n - 1].forEach(function (k) {
      var i = slides[k];
      if (i && !isVid(i) && !i.getAttribute('src')) i.src = i.getAttribute('data-src');
    });
  }
  // Ekrandaki video oynar, digerleri durur
  function media() {
    slides.forEach(function (el, k) {
      if (!isVid(el)) return;
      if (!box.hidden && k === cur) { playV(el); setTimeout(function () { if (!box.hidden && slides[cur] === el && el.paused) playV(el); }, 400); }
      else el.pause();
    });
  }
  function label() {
    count.textContent = (cur + 1) + ' / ' + slides.length + (isVid(slides[cur]) ? '' : '  ·  Büyütmek için iki parmakla açın');
  }
  function open(n) {
    if (!box) build();
    if (!slides.length) return;
    list.querySelectorAll('video').forEach(function (v) { v.pause(); });
    box.hidden = false;
    document.documentElement.classList.add('nk-zm-on');
    cur = Math.max(0, Math.min(n, slides.length - 1));
    load(cur);
    track.scrollLeft = cur * track.clientWidth;
    label();
    media();
  }
  function close() {
    reset(slides[cur]);
    box.hidden = true;
    document.documentElement.classList.remove('nk-zm-on');
    media();
    document.dispatchEvent(new Event('lm:recheck'));
  }

  /* Buyutme: iki parmak (pinch), cift dokunus, buyukken tek parmakla gezdirme; masaustunde tikla */
  function apply(i) { i.style.transform = 'translate(' + i._x + 'px,' + i._y + 'px) scale(' + i._s + ')'; }
  function reset(i) {
    if (!i || isVid(i)) return;
    i._s = 1; i._x = 0; i._y = 0; i.style.transform = '';
    track.classList.remove('nk-zm--lock');
  }
  function zoomTo(i, s) {
    i._s = s; i._x = 0; i._y = 0; apply(i);
    track.classList.toggle('nk-zm--lock', s > 1);
  }
  function pinch(slide, i) {
    i._s = 1; i._x = 0; i._y = 0;
    var d0 = 0, s0 = 1, px = 0, py = 0, x0 = 0, y0 = 0, last = 0;
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
    slide.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) { d0 = dist(e.touches); s0 = i._s; }
      else if (e.touches.length === 1) {
        px = e.touches[0].clientX; py = e.touches[0].clientY; x0 = i._x; y0 = i._y;
        var now = Date.now();
        if (now - last < 300) { zoomTo(i, i._s > 1 ? 1 : 2.5); last = 0; e.preventDefault(); return; }
        last = now;
      }
    }, { passive: false });
    slide.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && d0) {
        e.preventDefault();
        i._s = Math.max(1, Math.min(4, s0 * dist(e.touches) / d0));
        if (i._s === 1) { i._x = 0; i._y = 0; }
        apply(i);
        track.classList.toggle('nk-zm--lock', i._s > 1);
      } else if (e.touches.length === 1 && i._s > 1) {
        e.preventDefault();
        i._x = x0 + e.touches[0].clientX - px;
        i._y = y0 + e.touches[0].clientY - py;
        apply(i);
      }
    }, { passive: false });
    slide.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) d0 = 0;
      if (i._s < 1.05) reset(i);
    });
    slide.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: hover)').matches && e.target === i) zoomTo(i, i._s > 1 ? 1 : 2.2);
    });
  }

  document.addEventListener('click', function (e) {
    var li = e.target.closest && e.target.closest('.product__media-list .product__media-item');
    if (!li || e.target.closest('.nk-zm')) return;
    var all = items(), n = all.indexOf(li);
    if (n < 0) return;
    e.preventDefault();
    e.stopPropagation();
    open(n);
  }, true);
  // iOS Safari tiklanamaz ogelere click gondermez; her gorsele bos dinleyici ekleyerek dokunmayi garanti et
  list.querySelectorAll('.product__media-item').forEach(function (li) { li.addEventListener('click', function () {}); });
  // Goruntuleyici acikken iPhone'un sayfa yakinlastirmasini engelle (kendi pinch'imiz calissin)
  ['gesturestart', 'gesturechange'].forEach(function (t) {
    document.addEventListener(t, function (e) { if (box && !box.hidden) e.preventDefault(); }, { passive: false });
  });
})();
